import { getPromoMetricByNameKeyName } from 'components/molecules/TradePromoOptimization/tpoHelperMethods';
import { TpoMessages } from 'constants/tpo';
import { ProductPPG, PromoConfigDictionary, PromoEvent } from 'types/tradePromoOptimization';
import { tpoPromoMetricKeys } from 'utils/Enums';
import { sendNotification } from 'utils/helperMethods';

export const validateTPOAdjustedBaseUnits = (
    selectedEventInfo: PromoEvent | null,
    promoConfigDictionary: PromoConfigDictionary,
) => {
    const currentPromo = selectedEventInfo?.currentPromoTactic;
    if (!currentPromo) return false;
    const negativeTPOUnitsPPGs: string[] = [];
    currentPromo?.ppgs
        ?.filter((p: ProductPPG) => p.isSelected)
        .forEach((ppg: ProductPPG) => {
            const adjustedBaseUnits = getPromoMetricByNameKeyName(
                promoConfigDictionary,
                tpoPromoMetricKeys.TPO_ADJUSTED_BASE_UNITS,
            );

            const negativeTPO = Number(ppg.metrics.find((m) => m.id === adjustedBaseUnits.id)?.value ?? 0) < 0;
            if (negativeTPO) {
                negativeTPOUnitsPPGs.push(ppg.name);
            }
        });

    if (negativeTPOUnitsPPGs.length > 0) {
        sendNotification('error', TpoMessages.error.TPO_ADJUSTED_BASE_UNITS_CANNOT_BE_NEGATIVE(negativeTPOUnitsPPGs));
        return true;
    }

    return false;
};
